import SweepOptionType from '../store/schema/SweepOptionType';
import sweepStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Show or hide the sweep dialog
 * @param shouldShow whether this is to show the sweep dialog
 * @param state the state which contains the sweep store
 */
export default action('showHideSweepDialog')(select({
    sweepStore: function () { return sweepStore; },
})(function showHideSweepDialog(shouldShow, state) {
    state.sweepStore.isSweepDialogShown = shouldShow;
    if (!shouldShow) {
        // Clear the sweep view state if hiding the sweep dialog
        state.sweepStore.sweepOptionType = SweepOptionType.All;
        state.sweepStore.sweepRequestStatus = 0 /* NotInitiated */;
    }
}));
//# sourceMappingURL=showHideSweepDialog.js.map